import React, { useRef, useState, useEffect } from "react";
import moonImg from "../../../../public/images/mobile_background_image.png";
import MobileLogo from "../../../assets/svg/MobileLogo";

export default function MobileUI() {
  const [showTeaser, setShowTeaser] = useState(false);
  const videoRef = useRef(null);

  // Lance le teaser et le fullscreen
  const handleShowTeaser = () => {
    setShowTeaser(true);
    setTimeout(() => {
      if (videoRef.current) {
        // Plein écran
        if (videoRef.current.requestFullscreen) {
          videoRef.current.requestFullscreen();
        } else if (videoRef.current.webkitRequestFullscreen) {
          videoRef.current.webkitRequestFullscreen();
        }
        videoRef.current.play();
      }
    }, 100);
  };

  // Ferme le teaser (appelé quand on sort du fullscreen ou sur le bouton "X")
  const closeTeaser = () => {
    setShowTeaser(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else if (document.webkitFullscreenElement) {
        document.webkitExitFullscreen();
      }
    }
  };

  // Sur sortie du fullscreen : masque la vidéo
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (
        !document.fullscreenElement &&
        !document.webkitFullscreenElement
      ) {
        setShowTeaser(false);
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
    };
  }, []);

  return (
    <div className="mobileUI">
      <div className="mobileUI__background">
        <img src={moonImg} alt="image de l'experience mobile" />
      </div>
      <div className="mobileUI__header">
        <MobileLogo />
        <div className="mobileUI__header__title">
          <h1>La porte des rêves vous attend sur votre ordinateur</h1>
        </div>
      </div>
      <div className="mobileUI__footer">
        <div className="mobileUI__footer__buttons">
          <div className="mobileUI__footer__buttons__button">
            <button type="button" onClick={handleShowTeaser}>
              VOIR LE TEASER
              <svg width="161" height="40" viewBox="0 0 161 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M133.594 1.19115C143.7 4.12832 143.191 13.6341 147.805 17.594C153.429 22.4205 166.315 27.8637 157.506 32.2551C148.598 36.6958 125.767 35.5981 108.926 36.9757C96.134 38.0221 84.1768 39.1922 70.9125 39.3388C54.3521 39.5218 34.4165 41.3758 22.6484 37.9292C10.8856 34.4841 20.8133 28.4842 17.4847 23.691C13.9022 18.532 -5.7509 13.5942 2.50837 8.92699C10.7894 4.24746 35.0391 5.57461 52.1858 4.08186C65.4223 2.92953 77.6716 0.691969 91.3671 1.19115C105.35 1.70079 123.551 -1.7276 133.594 1.19115Z" fill="#F8F9FA"/>
              </svg>
            </button>
          </div>
          <div className="mobileUI__footer__buttons__button">
            <a href="https://reves.fr" target="_blank" rel="noopener noreferrer">
              REVES.FR
              <svg width="163" height="42" viewBox="0 0 163 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M134.594 2.19115C144.7 5.12832 144.191 14.6341 148.805 18.594C154.429 23.4205 167.315 28.8637 158.506 33.2551C149.598 37.6958 126.767 36.5981 109.926 37.9757C97.134 39.0221 85.1768 40.1922 71.9125 40.3388C55.3521 40.5218 35.4165 42.3758 23.6484 38.9292C11.8856 35.4841 21.8133 29.4842 18.4847 24.691C14.9022 19.532 -4.7509 14.5942 3.50837 9.92699C11.7894 5.24746 36.0391 6.57461 53.1858 5.08186C66.4223 3.92953 78.6716 1.69197 92.3671 2.19115C106.35 2.70079 124.551 -0.727598 134.594 2.19115Z" stroke="#F8F9FA" strokeWidth="2"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Overlay video plein écran */}
      {showTeaser && (
        <div
          className="teaser-video-overlay"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.96)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {/* Bouton fermer */}
          <button
            onClick={closeTeaser}
            style={{
              position: "absolute",
              top: 20,
              right: 30,
              fontSize: 32,
              background: "none",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              zIndex: 100001
            }}
            aria-label="Fermer la vidéo"
          >
            ×
          </button>
          {/* La vidéo */}
          <video
            ref={videoRef}
            src="/video/teaser.mp4"
            controls
            style={{ maxWidth: "100vw", maxHeight: "100vh", background: "#000" }}
          />
        </div>
      )}
    </div>
  );
}
